<template>
  <div class="person">
    <h1>个人中心页面</h1>
  </div>
</template>
<script>
export default {
  name: 'person'
}
</script>
<style lang="scss" scoped>

</style>


